<template>
  <div>
    <div class="header_content">
      <div class="title">
        <img
          class="logo"
          src="../../assets/img/newLogo.png"
          alt=""
          @click="indexBtn"
        />
        <div v-if="agentWebName" class="location_box">
          <i class="el-icon-location-information"></i>{{ agentWebName }}
        </div>
        <!-- <span
          style="
            color: #f00;
            position: absolute;
            left: 400px;
            font-size: 18px;
            font-weight: bold;
          "
          >测试中....</span
        > -->
        <div class="menu">
          <div class="nav">
            <p :class="active == 0 ? 'p_active' : ''" @click="indexBtn">首页</p>
            <p :class="active == 1 ? 'p_active' : ''" @click="contactBtn">
              联系我们
            </p>
            <p :class="active == 2 ? 'p_active' : ''" @click="aboutBtn">
              关于我们
            </p>
            <p :class="active == 3 ? 'p_active' : ''">
              <!-- 申请保函 -->
              <el-dropdown @command="applyFor">
                <a class="el-dropdown-link">
                  申请保函<i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="01">投标保函</el-dropdown-item>
                  <el-dropdown-item command="02">履约保函</el-dropdown-item>
                  <el-dropdown-item command="04">预付款保函</el-dropdown-item>
                  <el-dropdown-item command="03">质量保证保函</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
            <span></span>
          </div>
          <!-- 未登录 -->
          <div v-if="isLogin" class="login_register">
            <div class="login" @click="loginBtn">登录</div>
            <div class="register" @click="registerBtn">立即注册</div>
          </div>
          <!-- 登录后 -->
          <div v-else class="login_account">
            <div class="account_box" @click="userMsgBtn">
              <div class="cion_box"><i class="el-icon-s-custom"></i></div>
              <span>{{ user.name }} 的企业主页</span>
            </div>
            <div class="esc_box" @click="logoutSubmit">退出</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :width="dialogVisibleWidth"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div v-if="dialogUserVisible">
        <div v-if="isLoginShow" class="register_input_box">
          <i class="el-icon-close close_btn" @click="closeBtn"></i>
          <div class="title">
            {{ loginDialogType === 'reg' ? '注册保函在线' : '登录保函在线' }}
          </div>
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            :rules="rule_Form1"
            class="demo-ruleForm"
          >
            <el-form-item prop="iphone">
              <el-input
                size="medium"
                v-model="ruleForm.iphone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="!isPsd" prop="code">
              <el-input
                size="medium"
                v-model="ruleForm.code"
                placeholder="请输入验证码"
              >
                <el-tooltip slot="suffix" content="点击发送验证码">
                  <send-sms-code
                    :telephone="ruleForm.iphone"
                    :smsType="smsType"
                  />
                </el-tooltip>
              </el-input>
            </el-form-item>
            <el-form-item v-else prop="psd">
              <el-input
                size="medium"
                v-model="ruleForm.psd"
                placeholder="请输入密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button
            style="width: 100%; margin-top: 10px"
            size="medium"
            type="primary"
            @click="loginSubmit('ruleForm')"
            >{{ loginDialogType === 'reg' ? '注册' : '登录' }}</el-button
          >
          <div
            class="psd_login"
            v-if="loginDialogType === 'login'"
            @click="psdLogin"
          >
            {{ isPsd ? '切换验证码登录' : '切换账号密码登录' }}
          </div>
          <div class="psd_login" v-else @click="loginBtn">
            已有账号，直接登录
          </div>
          <div
            class="psd_login"
            v-if="loginDialogType === 'login'"
            @click="registerBtn"
          >
            还没有账号，注册一个
          </div>
          <div class="regulation">
            登录/注册即表示同意<span
              style="cursor: pointer"
              @click="goUserAgreement"
              >用户协议</span
            >、<span style="cursor: pointer" @click="goPrivacyAgreement"
              >隐私政策</span
            >
          </div>
        </div>
        <div v-else class="register_input_box">
          <div class="title">
            设置密码 <span class="close_etp" @click="closeEtp(1)">跳过</span>
          </div>
          <el-form
            :model="psdFrom"
            ref="ruleForm2"
            :rules="rule_Form2"
            class="demo-ruleForm"
          >
            <el-form-item prop="psd1">
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="line-height: 20px">
                  <p>长度为8-14个字符</p>
                  <p>密码要求至少一个大写字母、一个小写字母和一个数字</p>
                  <p>不允许有空格中文</p>
                </div>
                <el-input
                  size="medium"
                  v-model="psdFrom.psd1"
                  placeholder="设置密码"
                  show-password
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item prop="psd2">
              <el-input
                size="medium"
                v-model="psdFrom.psd2"
                placeholder="确认密码"
                show-password
              ></el-input>
            </el-form-item>
          </el-form>
          <el-button
            style="width: 100%"
            size="medium"
            type="primary"
            @click="setPwdBtn('ruleForm2')"
            >下一步</el-button
          >
        </div>
      </div>
      <div v-else class="register_input_box">
        <div class="title">
          填写企业信息 <span class="close_etp" @click="closeEtp(2)">跳过</span>
        </div>
        <edit-company></edit-company>
      </div>
    </el-dialog>
     
  </div>
</template>

<script>
import { getAgent } from '@/api/agent/agent'
import { SITE_KEY, TOKEN_KEY, WEB_USER } from '@/utils/constant'
import { uasReg, uasLogin, uasResetPwd } from '@/api/user/uas'
import { detailU, loginOut, setPwd ,getCaptcha} from '@/api/user/user'
import { updateC } from '@/api/user/company'
import SendSmsCode from '@/components/SendSmsCode'
import mainDataAddr from '../MainData/mainDataAddr.vue'
import EditCompany from '../editCompany.vue'
export default {
  data() {
    return {
      appId: 'portal',
      agentWebName: sessionStorage.getItem('agentWebName'), // 有值的时候显示分站
      isLogin: true, //true:显示未登录区域；false：显示已登录区域
      loginDialogType: 'login', //弹窗形式：login:登录；reg:注册
      loginType: 1, //0：账号和密码登录；1：验证码登录
      smsType: 'login',
      dialogVisible: false,
      dialogVisibleWidth: '500px',
      captchaVisible: false,
      captchaLoading: false,
      captchaSrc: '',
      captchaForm: {},
      dialogUserVisible: false,
      isLoginShow: false, //是否显示登录窗口区域
      active: 0,
      etpRegAddress: {
        province: '',
        city: '',
        addr: ''
      }, //企业注册地址
      ruleForm: {
        iphone: '',
        code: '',
        psd: '',
        agentGuid: ''
      },
      rule_Form1: {
        iphone: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
        psd: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]+$/,
            message: '密码要求至少一个大写字母、一个小写字母和一个数字',
            trigger: 'blur'
          }
        ]
      },
      rule_Form2: {
        psd1: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]+$/,
            message: '密码要求至少一个大写字母、一个小写字母和一个数字',
            trigger: 'blur'
          }
        ],
        psd2: [{ required: true, message: '确认密码不能为空', trigger: 'blur' }]
      },
      rule_Form3: {
        etpName: [
          { required: true, message: '企业名称不能为空', trigger: 'blur' }
        ],
        etpUscc: [
          {
            required: true,
            message: '统一社会信用代码不能为空',
            trigger: 'blur'
          }
        ],
        etpLegal: [
          {
            required: true,
            message: '法人姓名不能为空',
            trigger: 'blur'
          }
        ],
        etpContact: [
          {
            required: true,
            message: '联系人不能为空',
            trigger: 'blur'
          }
        ],
        etpContactPhone: [
          {
            required: true,
            message: '联系人电话不能为空',
            trigger: 'blur'
          }
        ]
      },
      agent: {},
      user: {},
      psdFrom: {
        psd1: '',
        psd2: ''
      },
      enterpriseFrom: {
        value1: '',
        data: ''
      },
      isPsd: false,
      userGuid: ''
    }
  },
  components: {
    SendSmsCode,
    mainDataAddr,
    EditCompany
  },
  mounted() {
    this.initMenus()
    this.getAgentInfo()
    this.getUserInfo()
  },
  methods: {
    applyFor(command) {
      if (!sessionStorage.getItem(TOKEN_KEY)) {
        return this.$message.error('请先登录')
      }
      if (command == '01') {
        this.$router.push({ path: '/applyFor' })
      } else {
        this.$router.push({
          path: '/applyForMore',
          query: { guaranteeCategory: command }
        })
      }
    },
    initAddr(originAddr) {
      this.enterpriseFrom.etpProvince = originAddr.province
      this.enterpriseFrom.etpCity = originAddr.city
      this.enterpriseFrom.etpAddr = originAddr.addr
    },
    initMenus() {
      //test
      // this.dialogVisible=true
      // this.dialogVisibleWidth='500px'
      const url = this.$route.path
      if (url.indexOf('contact') > -1) {
        this.active = 1
      } else if (url.indexOf('about') > -1) {
        this.active = 2
      } else if (url.indexOf('applyFor') > -1) {
        this.active = 3
      } else {
        this.active = 0
      }
    },
    getUserInfo() {
      const tokenKey = sessionStorage.getItem(TOKEN_KEY)
      if (tokenKey) {
        console.log(TOKEN_KEY + ':' + tokenKey)
        detailU().then((res) => {
          if (res.success) {
            this.user = res.result
            sessionStorage.setItem(WEB_USER, JSON.stringify(res.result))
            this.isLogin = false
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    getAgentInfo() {
      const path = this.$route.query
      const agentWebUrl = path.agt
      if (agentWebUrl) {
        const data = {
          agentWebUrl
        }
        getAgent(data).then((res) => {
          console.log(res)
          if (res.success) {
            this.agent = res.result
            this.agentWebName = res.result.agentWebName
            sessionStorage.setItem('agentWebName', res.result.agentWebName)
            // 设置全局agent
            sessionStorage.setItem(SITE_KEY, this.agent.guid)
          }
        })
      }
    },
    closeEtp(v) {
      if (v == 1) {
        this.dialogUserVisible = false
        this.dialogVisibleWidth = '750px'
      } else {
        this.dialogVisible = false
        location.reload()
      }
    },
    indexBtn() {
      this.$router.push({ path: '/' })
    },
    contactBtn() {
      this.$router.push({ path: '/contact' })
    },
    aboutBtn() {
      this.$router.push({ path: '/about' })
    },

    loginSubmit(formName) {
      // 登录
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loginDialogType === 'login') {
            //登录
            const data = {
              loginName: this.ruleForm.iphone,
              loginPwd: this.ruleForm.psd,
              code: this.ruleForm.code,
              loginType: this.loginType,
              appId: this.appId
            }
            uasLogin(data).then((res) => {
              console.log(res)
              if (res.success) {
                sessionStorage.setItem(TOKEN_KEY, res.result)
                location.reload()
              } else {
                this.$message.error(res.message)
                this.ruleForm.code = ''
              }
            })
          } else {
            // 如果是注册，进行后续注册
            const data = {
              loginName: this.ruleForm.iphone,
              code: this.ruleForm.code,
              loginType: this.loginType,
              agentId: sessionStorage.getItem(SITE_KEY),
              appId: this.appId
            }
            uasReg(data).then((res) => {
              this.isLoginShow = false
              if (res.success) {
                sessionStorage.setItem(TOKEN_KEY, res.result)
                this.dialogUserVisible = true
              } else {
                this.$message.error(res.message)
                this.dialogVisible = false
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    logoutSubmit() {
      loginOut().then((res) => {
        if (res.success) {
          sessionStorage.removeItem(TOKEN_KEY)
          sessionStorage.removeItem(SITE_KEY)
          this.isLogin = true
        } else {
          this.$message.error(res.message)
        }
      })
    },
    setPwdBtn(formName) {
      // 下一步
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //设置密码成功，完善企业信息
          //调用设置密码接口,设置密码
          //验证成功后，显示完善企业信息
          const data = {
            loginPwd: this.psdFrom.psd1
          }
          setPwd(data).then((res) => {
            if (res.success) {
              this.dialogVisibleWidth = '750px'
              this.dialogUserVisible = false
            } else {
              this.$message.error(res.message)
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    etpBtn(formName) {
      // 企业信息保存
      if (this.enterpriseFrom.etpCertBeginDate) {
        this.enterpriseFrom.etpCertBeginDate = Date.parse(
          this.enterpriseFrom.etpCertBeginDate
        )
      }
      if (this.enterpriseFrom.etpCertEndDate) {
        this.enterpriseFrom.etpCertEndDate = Date.parse(
          this.enterpriseFrom.etpCertEndDate
        )
      }
      console.log(this.enterpriseFrom)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = this.enterpriseFrom
          updateC(data).then((res) => {
            if (res.success) {
              this.$message.success('企业信息维护成功')
              location.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    loginBtn() {
      this.dialogVisible = true
      this.dialogVisibleWidth = '500px'
      this.dialogUserVisible = true
      this.isLoginShow = true
      this.isPsd = false
      this.smsType = 'login'
      this.ruleForm.code = ''
      this.loginDialogType = 'login'
    },
    registerBtn() {
      // 立即注册
      this.dialogVisible = true
      this.dialogVisibleWidth = '500px'
      this.dialogUserVisible = true
      this.isLoginShow = true
      this.smsType = 'reg'
      this.isPsd = false
      this.loginDialogType = 'reg'
    },
    closeBtn() {
      // 关闭弹框
      this.dialogVisible = false
    },
    psdLogin() {
      // 账号密码登录
      this.isPsd = !this.isPsd
      this.isPsd ? (this.loginType = 0) : (this.loginType = 1)
    },
    userMsgBtn() {
      this.$router.push({ path: '/bidBondAdmin' })
    },
    goUserAgreement() {
      // 用户协议
      window.open('/privacyAgreement', '_blank')
    },
    goPrivacyAgreement() {
      // 隐私政策
      window.open('/privacyAgreement', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
@import './index.scss';
.el-dropdown-link {
  color: #333;
}
</style>
